import { render, staticRenderFns } from "./LoginLicenseActivation.vue?vue&type=template&id=36bfa8f0&scoped=true&"
import script from "./LoginLicenseActivation.vue?vue&type=script&lang=js&"
export * from "./LoginLicenseActivation.vue?vue&type=script&lang=js&"
import style0 from "./LoginLicenseActivation.vue?vue&type=style&index=0&id=36bfa8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfa8f0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36bfa8f0')) {
      api.createRecord('36bfa8f0', component.options)
    } else {
      api.reload('36bfa8f0', component.options)
    }
    module.hot.accept("./LoginLicenseActivation.vue?vue&type=template&id=36bfa8f0&scoped=true&", function () {
      api.rerender('36bfa8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginLicenseActivation.vue"
export default component.exports